import './style.scss'
import { Media } from '../../../js/utils/const'
import { Slider } from '../../../js/components/Slider/Slider'
import { CartModal } from '../../../js/components/CartModal/scripts'

export default !function () {
  const block = document.querySelector('.tariffs-v4')

  if (!block) {
    return
  }

  const blockName = block.dataset?.blockName || 'Блок без названия'
  const wrapper = block.querySelector('.tariffs-v4__content')
  const items = block.querySelectorAll('.tariffs-v4__item')

  const options = {
    wrapper,
    lazy: true,
    settings: {
      loop: false,
      autoScrollOffset: 1,
      centeredSlides: true,
      centerInsufficientSlides: true,
      centeredSlidesBounds: true,
      slideClass: 'tariffs-v4__item',
      wrapperClass: 'tariffs-v4__list',
      spaceBetween: 8,
    },
    initCondition: {
      sm: items.length > 1,
      md: items.length > 1,
      lg: false,
      xl: false
    },
    createCallback: (slider) => {
      slider?.slideTo?.(1, 0)
      wrapper.classList.remove('tariffs-v4__content--static')
    },
    destroyCallback: () => {
      wrapper.classList.add('tariffs-v4__content--static')
    }
  }

  new Slider(options).init()

  const headers = block.querySelectorAll('.tariffs-v4__top')
  const features = block.querySelectorAll('.tariffs-v4__features')
  const indexToHeight = new Map()
  const matchMedia = {
    sm: window.matchMedia(`(max-width: ${Media.SM_MAX}px)`),
    lg: window.matchMedia(`(min-width: ${Media.LG}px)`)
  }

  const loopAtFeatures = (lists, callback) => {
    lists.forEach((list) => {
      const items = list.querySelectorAll('.tariffs-v4__feature')
      items.forEach(callback)
    })
  }

  const fillHeightMap = (item, i) => {
    item.removeAttribute('style')
    const height = item.clientHeight

    indexToHeight.set(i, indexToHeight.has(i)
      ? Math.max(indexToHeight.get(i), height)
      : height
    )
  }

  const setItemHeight = (item, i) => {
    item.style.height = indexToHeight.has(i) ? `${indexToHeight.get(i)}px` : 'auto'
  }

  const setHeight = (elements) => {
    const heights = [...elements].map((p) => {
      p.removeAttribute('style')
      return p.clientHeight
    })
    const maxHeight = Math.max(...heights)

    elements.forEach((el) => {
      el.style.height = `${maxHeight}px`
    })
  }
  const updateItemHeight = () => {
    indexToHeight.clear()
    setHeight(headers)
    loopAtFeatures(features, fillHeightMap)
    loopAtFeatures(features, setItemHeight)
  }

  const resizeObserver = new ResizeObserver((entries) => {
    window.requestAnimationFrame(() => {
      for (const entry of entries) {
        if (entry.target === block.querySelector('.tariffs-v4__content')) {
          updateItemHeight()
        }
      }
    })
  })

  resizeObserver.observe(wrapper)

  updateItemHeight()
  matchMedia.sm.addEventListener('change', updateItemHeight)
  matchMedia.lg.addEventListener('change', updateItemHeight)

  block.addEventListener('click', (evt) => {
    const button = evt.target.closest('.tariffs-v4__button')

    if (button) {
      const card = button.closest('.tariffs-v4__item')
      const data = JSON.parse(card.dataset.tariffData)

      /* eslint-disable-next-line */
      !isGbHost && window.$analytics?.push('fl-show-form')

      window.$analytics?.push('tariff-subscribe-button-click', {
        tariffName: data.name,
        blockName
      });

      new CartModal({ blockName, tariffData: data }).init();
    }
  })
}()
